import React from 'react';
import LeaderboardEntry from './LeaderboardEntry';
import { LeaderboardEntry as LeaderboardEntryType } from './LeaderboardTypes';
import { 
  ListContainer, 
  LoadingMessage, 
  ErrorMessage 
} from './LeaderboardStyles';

interface LeaderboardListProps {
  entries: LeaderboardEntryType[];
  isLoading: boolean;
  error: string | null;
}

const LeaderboardList: React.FC<LeaderboardListProps> = ({ 
  entries, 
  isLoading, 
  error 
}) => {
  if (isLoading) {
    return <LoadingMessage>Loading leaderboard data...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>{error}</ErrorMessage>;
  }

  return (
    <ListContainer>
      {entries.map((entry, index) => (
        <LeaderboardEntry 
          key={entry.userId} 
          entry={entry} 
          position={index + 1} 
        />
      ))}
    </ListContainer>
  );
};

export default LeaderboardList; 